module.exports = __webpack_public_path__ + "static/media/coverProducer.823fb528.png";